import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { emptyArr } from '@beef/utils';
import { createMergedBlockSelector } from "../../selectors";
import { getFAQBlock } from "../selectors";
var getFaqData = createMergedBlockSelector(getFAQBlock);
export var getFaqTitle = function getFaqTitle(state) {
  return getFaqData(state).title || '';
};
export var getFaqContent = function getFaqContent(state) {
  return getFaqData(state).faq || '';
};
export var getFaqRegion = function getFaqRegion(state) {
  return getFaqContent(state).region || '';
};
export var getFaqRegionin = function getFaqRegionin(state) {
  return getFaqContent(state).regionin || '';
};
export var getFaqDataList = function getFaqDataList(state) {
  return getFaqContent(state).list || emptyArr;
};
export var getFaqCategories = function getFaqCategories(state) {
  return getFaqContent(state).categories || emptyArr;
};
export var getFullAddress = function getFullAddress(state) {
  return getFaqData(state).fullAddress || emptyArr;
};
export var getClickedFAQTitle = function getClickedFAQTitle(state, faqId) {
  var _data$tabs$find;
  var _getFaqDataList = getFaqDataList(state),
    _getFaqDataList2 = _slicedToArray(_getFaqDataList, 1),
    data = _getFaqDataList2[0];
  return (_data$tabs$find = data.tabs.find(function (_ref) {
    var id = _ref.id;
    return id === faqId;
  })) === null || _data$tabs$find === void 0 ? void 0 : _data$tabs$find.title;
};